// Version : 0.0.1
// LastEdit : KARTHEESWARAN
// MODFIED DATE:12-11-2025
//Last ADD : REMOVE COMMENTED LINES

import { takeLatest, put, all, call } from 'redux-saga/effects';
import AttendanceReportActionTypes from './attendance-report.types';
import { attendanceReportListGet } from './attendance-report.services';
import {
	getAttendanceReportDetailsSuccess,
	getAttendanceReportDetailsFailure,
	getAttendanceReportDetailsResponseChanged,
} from './attendance-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *************  START GET ATTENDANCE REPORT DETAILS  ***************** */
export function* getAttendanceReportList({ payload }: any) {
	try {
		const key = 'GetAttendanceReportKey';
		const { companyID, userID, officerID, locationID, branchID, databaseName, toDate } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			OfficerID: officerID,
			CenterID: locationID,
			BranchID: branchID,
			DatabaseName: databaseName,
			RePayDate: toDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(attendanceReportListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAttendanceReportDetailsFailure(responseData.data));
		} else {
			yield put(getAttendanceReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAttendanceReportDetailsFailure(error));
	}
}

export function* resetGetAttendanceReportListResponse() {
	yield put(getAttendanceReportDetailsResponseChanged());
}

export function* onGetAttendanceReportListDetails() {
	yield takeLatest(
		AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_START,
		getAttendanceReportList,
	);
}

export function* onGetAttendanceReportListResponseReset() {
	yield takeLatest(
		AttendanceReportActionTypes.GET_ATTENDANCE_REPORT_LIST_RESPONSE_RESET,
		resetGetAttendanceReportListResponse,
	);
}
/** *********************  END GET ATTENDANCE REPORT LIST ******************** */

export function* attendanceReportSaga() {
	yield all([
		call(onGetAttendanceReportListDetails),
		call(onGetAttendanceReportListResponseReset),
	]);
}
